/** zh-CN catalogue `expr` (W3-09; English: src/core/expr/expr.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'expr',
  locale: 'zh-CN',
  messages: {
    empty: '请输入数字或表达式，例如 12、+=10 或 lerp(-400, 400, u)',
    emptyAfterAssign: '请在“{op}”后输入一个值，例如 {op} 10',
    unexpectedChar: '表达式中不能使用字符“{char}”',
    unexpectedToken: '意外的“{token}”',
    unexpectedEnd: '末尾缺少内容',
    expectedValue: '此处应为数字、名称或“(”，而不是“{token}”',
    missingOperator: '“{token}”前缺少运算符，例如 * 或 +',
    unitSpace: '单位要紧跟在数字后面，例如 {example}',
    unitSpaceOrMul: '写成 {example} 表示单位，或写成 {num} * {name} 表示相乘',
    percentOrRemainder: '请加上空格表明意图：{num}% {sign} {rest} 表示百分比，{num} % {sign}{rest} 表示取余',
    percentSpace: '“{rest}”前缺少运算符：写成 {num}% * {rest} 表示百分比相乘，或写成 {num} % {rest} 表示取余',
    unclosedParen: '这个“(”没有闭合：请添加“)”',
    unmatchedParen: '这个“)”没有对应的“(”',
    strayComma: '逗号只用于分隔函数的参数，例如 max(a, b)',
    assignNotFirst: '“{op}”必须放在最前面，例如 {op} 10',
    assignHere: '此处只需输入值，不要写“{op}”',
    unclosedString: '请用相同的引号结束缓动名称',
    badDollar: '请写成 $t$ 或直接写 t',
    badNumber: '“{text}”不是有效的数字',
    numberTooLarge: '这个数字太大了',
    tooDeep: '这个表达式嵌套层数过深',
    unknownUnit: '未知单位“{unit}”。可用单位：px、%、deg、s、ms、b（拍）和 v（速度）',
    implicitMul: '请写成 {num} * {name} 表示相乘',
    speedUnitHere: '速度单位 v 只能用于运动数值，例如关键帧和区段的值',
    unknownName: '未知名称“{name}”',
    unknownNameSuggest: '未知名称“{name}”。你是不是想输入 {suggestion}？',
    varNotHere: '此处不能使用“{name}”。可以使用：{list}',
    notAFunction: '“{name}”是一个值，不是函数',
    unknownFunction: '未知函数“{name}”',
    unknownFunctionSuggest: '未知函数“{name}”。你是不是想输入 {suggestion}？',
    needsCall: '{name} 是一个函数：请写成 {signature}',
    argCount: '{signature} 需要 {count, plural, other {# 个值}}',
    argCountRange: '{signature} 需要 {min} 到 {max} 个值',
    argCountMin: '{signature} 至少需要 {min, plural, other {# 个值}}',
    stringHere: '引号中的文本只用于缓动名称，例如 ease("outQuad", u)',
    unknownEasing: '未知缓动“{name}”。请使用 1 到 29 的缓动编号或 outQuad 这样的名称',
    unknownEasingSuggest: '未知缓动“{name}”。你是不是想输入 {suggestion}？',
    easingId: '缓动编号是 1 到 29 之间的整数',
    mixedUnits: '此处不能把 {a} 和 {b} 的值组合在一起',
    mixedTime: '拍和秒不能混用：请用 beat(...) 或 sec(...) 转换',
    unitProduct: '两个带单位的值不能相乘（{a} 和 {b}）',
    unitQuotient: '只有同单位的值才能除以 {b} 单位的值',
    speedUnitOp: '速度值（v）只能相加、相减或乘以一个数',
    scaleByUnit: '{op} 不能使用速度单位 v：请使用 =、+= 或 -=',
    fieldWantsBeats: '此输入框使用拍：请用 beat(...) 转换秒数',
    fieldWantsSeconds: '此输入框使用秒：请用 sec(...) 转换拍数',
    timeUnitUnknown: '请去掉“{unit}”，以此输入框的单位输入时间',
    fieldNotTime: '此输入框不接受时间：请去掉“{unit}”',
    timeAsNumber: '时间在此处不能当作普通数字使用：请将其除以一个时间，例如 {example}',
    beatArg: 'beat(...) 将以秒为单位的时间转换为拍数',
    secArg: 'sec(...) 将拍数转换为秒',
    divByZero: '除以零',
    modByZero: '除以零的余数没有定义',
    undefinedFn: '{name}(...) 对此值没有定义',
    undefinedPow: '此幂运算没有定义（例如负数的分数次幂）',
    tooLarge: '结果太大',
    notFinite: '结果不是有效的数字',
    missingValue: '此项目没有“{name}”的值',
    needsTempo: '{name}(...) 需要速度表，但此处不可用',
    needsSegment: '速度单位 v 需要一个区段：此项目没有区段的起始值或时长',
    roundDigits: 'round(x, digits) 的位数必须是 -15 到 15 之间的整数',
    easingRuntime: 'ease(...) 需要 1 到 29 之间的整数缓动编号，而不是 {id}',
    'var.v': '此输入框的当前值',
    'var.i': '项目按时间顺序的序号，从 0 开始',
    'var.n': '选中项目的数量',
    'var.u': '在选中内容中的位置，从 0（第一项）到 1（最后一项）',
    'var.t': '项目所在的拍数',
    'var.s': '项目的时间（秒）',
    'var.x': '音符的 X 位置',
    'var.speed': '音符的速度',
    'var.size': '音符的宽度',
    'var.v0': '区段起点的值',
    'var.v1': '区段终点的值',
    'var.len': '区段的长度（拍）',
    'var.pathT': '沿路径的进度，从 0（起点）到 1（终点）',
    'var.pathBeat': '路径上此点的拍数',
    'const.pi': '圆周率 π，3.14159…',
    'const.e': '自然常数 e，2.71828…',
    'fn.abs': '到零的距离：abs(-3) 等于 3',
    'fn.min': '这些值中最小的一个',
    'fn.max': '这些值中最大的一个',
    'fn.clamp': '将 x 限制在 lo 和 hi 之间',
    'fn.round': '四舍五入到最接近的整数，或指定的小数位数',
    'fn.floor': '向下取整',
    'fn.ceil': '向上取整',
    'fn.sqrt': '平方根',
    'fn.pow': 'x 的 y 次幂（与 x ^ y 相同）',
    'fn.exp': 'e 的 x 次幂',
    'fn.log': '自然对数，或以给定底数的对数',
    'fn.sin': '正弦（弧度，或写成 30deg 的角度）',
    'fn.cos': '余弦（弧度，或写成 30deg 的角度）',
    'fn.tan': '正切（弧度，或写成 30deg 的角度）',
    'fn.asin': '反正弦，单位为弧度',
    'fn.acos': '反余弦，单位为弧度',
    'fn.atan': '反正切，单位为弧度',
    'fn.atan2': '点 (x, y) 的角度，单位为弧度',
    'fn.sign': '正数为 1，负数为 -1，零为 0',
    'fn.lerp': '随 u 从 0 变到 1，从 a 变到 b',
    'fn.ease': '对 u（0 到 1）应用缓动：1 到 29 的 RPE 缓动编号或 outSine 这样的名称，可只使用曲线的一部分',
    'fn.bezier': '对 u 应用自定义曲线（三次贝塞尔控制柄）',
    'fn.alt': '逐项循环使用这些值：第一项取 a，第二项取 b，依此类推',
    'fn.rand': 'a 和 b 之间的随机数，相同种子每次结果相同',
    'fn.randn': '以 mu 为中心、离散程度为 sigma 的随机数（正态分布）',
    'fn.snap': '将 x 取整到最接近的 step 的倍数',
    'fn.beat': '用速度表将以秒为单位的时间转换为拍数',
    'fn.sec': '用速度表将拍数转换为秒',
    'unit.px': '像素（数字不变）',
    'unit.pct':
      '百分比：50% 即 50，u * 100% 仍是百分比。用于缩放某个值时它是分数：*= 50% 表示减半，v * 120% 表示 v 的 1.2 倍。两个值之间的 7 % 2 表示取余',
    'unit.deg': '角度（用于 sin、cos 和 tan 时会换算）',
    'unit.s': '秒，会换算为此输入框的单位',
    'unit.ms': '毫秒，会换算为此输入框的单位',
    'unit.b': '拍',
    'unit.v':
      '速度：3v 表示以速度 3 在区段内移动的距离（每单位每秒 120 像素）。使用 = 时，单独的距离从区段起点算起：= 3v 等同于 = v0 + 3v',
    'assign.set': '将每个选中的项目设为该值',
    'assign.add': '将该值加到当前值上',
    'assign.sub': '从当前值中减去该值',
    'assign.mul': '将当前值乘以该值',
    'assign.div': '将当前值除以该值',
  },
};

export default catalog;
